export const UPDATE_PAGE = 'UPDATE_PAGE'
export const UPDATE_CONTEXT = 'UPDATE_CONTEXT'
export const UPDATE_ACTIVE_PAGE = 'UPDATE_ACTIVE_PAGE'

export const REGISTER_NAVIGATION_CALLBACK = 'REGISTER_NAVIGATION_CALLBACK'
export const UNREGISTER_NAVIGATION_CALLBACK = 'UNREGISTER_NAVIGATION_CALLBACK'

export const HOMEPAGE = ''
